/**
 * Generates a preview of the next dynamic numbering values.
 * @param {string} prefix1 - First prefix
 * @param {string} prefix2 - Second prefix
 * @param {string|number} nextNumber - Next base number
 * @returns {string} Preview of the next 3 numbers
 */
export const buildNextNumbersPreview = (prefix1, prefix2, nextNumber) => {
  const prefixA = (prefix1 ?? "").trim()
  const prefixB = (prefix2 ?? "").trim()
  const base = Number(nextNumber)
  const valid = Number.isFinite(base) && base >= 1
  const n1 = valid ? base : 1
  const n2 = valid ? base + 1 : 2
  const n3 = valid ? base + 2 : 3

  const makeCode = num => {
    const a = prefixA ? `${prefixA}-` : ""
    const b = prefixB ? `${prefixB}-` : ""
    return `${a}${b}${num}`
  }

  return `${makeCode(n1)}, ${makeCode(n2)}, ${makeCode(n3)}...`
}

export default buildNextNumbersPreview
